export default __webpack_public_path__ + "static/media/art-pro-red-poster-1.a91d885b.jpg";